module.exports = __webpack_public_path__ + "static/media/scenarioBg.2df7a583.jpg";